/**
 * Base & accessories order, taken from the plan's Base&accessories tab row
 * order so the two read side by side.
 *
 * The tab mixes two kinds of thing: bases and poles that are sold directly
 * (CFMT, CRL, RL, TB, PC, UC), and binding/trim components that are only
 * ever consumed inside covers (BD*, FT-*). Both belong here because that is
 * how the workbook plans them.
 */
export const BASE_SORT_ORDER: readonly string[] = [
  "CFMT160-BLACK",
  "CFMT160-BRONZE",
  "CFMT160-HAMMERTONE-GREY",
  "CFMT160-WHITE",
  "CFMT172-BLACK",
  "CFMT172-BRONZE",
  "CFMT172-HAMMERTONE-GREY",
  "CFMT172-WHITE",
  "CRL070",
  "CRL070-BLACK",
  "CRL070-WHITE",
  "CRL100",
  "CRL100-BLACK",
  "CRL100-WHITE",
  "CRLY903-BLACK",
  "RL50",
  "RL80",
  "SD51-117",
  "SD51-302",
  "TB50",
  "TB52",
  "TB60",
  "DISD912",
  "CRLY905-PLATE100",
  "CRLY905-PLATE70",
  "TSB4-201",
  "CR16",
  "BDNATURAL",
  "BDNAVY",
  "BDBLACK",
  "BDGREY",
  "FT-FRN11-SA04",
  "FT-FRN11-SA08",
  "FT-FRN11-SA39",
  "FT-FRN11-SA61",
  "FT-TAS11-SA04",
  "FT-TAS11-SA08",
  "FT-TAS11-SA39",
  "FT-TAS11-SA61",
  "PC301",
  "PC302",
  "PC303",
  "PC305",
  "PC306",
  "PC307",
  "PC309",
  "PC310",
  "PC311",
  "PC312",
  "PC314",
  "PC315",
  "PT-CRL-12-BT",
  "UC100",
  "UC101",
  "UC102",
  "FRINGE",
  "FRINGE-BEIGE",
  "FRINGE-BLUE",
  "FRINGE-YELLOW",
  "PT-TASSEL-ANTIQUE BEIGE",
  "PT-TASSEL-PACIFIC BLUE",
];

const BASE_INDEX = new Map(BASE_SORT_ORDER.map((s, i) => [s, i]));

export function baseSortRank(itemid: string): number {
  return BASE_INDEX.get(itemid) ?? Number.MAX_SAFE_INTEGER;
}
